import { render, staticRenderFns } from "./login-layout.vue?vue&type=template&id=61358a30"
import script from "./login-layout.vue?vue&type=script&lang=js"
export * from "./login-layout.vue?vue&type=script&lang=js"
import style0 from "./login-layout.vue?vue&type=style&index=0&id=61358a30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports